import { render, staticRenderFns } from "./WordIcon.vue?vue&type=template&id=4a908028"
import script from "./WordIcon.vue?vue&type=script&lang=js"
export * from "./WordIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports